import { Box, Grid, Button, Typography, Divider } from "@mui/material";
import Link from "@mui/material/Link";
import { useState } from "react";
import FormPersonalInfo from "./FormPersonalInfo";
import ServiceInfo from "./ServiceinFo";
import PersonSign from "./PersonSign";
import AttachEvidence from "./AttachEvidence";
import Swal from "sweetalert2";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import { useHistory } from "react-router-dom"; // version 5.2.0

export default function MainFormPersonaNew() {
  const [activeStep, setActiveStep] = useState(0);
  const steps = ["Step 1", "Step 2", "Step 3", "Step 4"];

  // State สำหรับเก็บข้อมูลจากฟอร์ม
  const [formData, setFormData] = useState({
  //FormDataPersonalInfo
  write_at: "",
  write_date: "",
  firstname_th: "",
  lastname_th: "",
  age: "",
  nationality: "",
  full_cid: "",
  license_code: "",
  //FormDataPersonal
  business_name_th: "",
  business_firstname_th_1: "",
  business_lastname_th_1: "",
  business_full_cid_1: "",
  business_firstname_th_2: "",
  business_lastname_th_2: "",
  business_full_cid_2: "",
  business_type: "",
  business_create_date: "",
  business_code: "",
  //ที่อยู่ที่สามารถติดต่อได้ current_address
  current_address:{
    address: "",
    moo: "",
    soi: "",
    street: "",
    sub_district: "",
    district: "",
    province: "",
    zip_code: "",
    email: "",
    mobile_number: "",
    }
  });


  const [errors, setErrors] = useState<{ [key: string]: boolean }>({});
  const history = useHistory();

  // ฟังก์ชันตรวจสอบข้อมูล
  const validateForm = () => {
    let newErrors: { [key: string]: boolean } = {};

    // Object.entries(formData).forEach(([key, value]) => {
    //   if (!value) newErrors[key] = true;
    // });

    // ตรวจสอบ formDataLegalEntity โดยไม่เช็คค่า firstName2, lastName2, citizenId2
    Object.entries(formData).forEach(([key, value]) => {
      // ตรวจสอบค่าเฉพาะฟิลด์ที่ไม่ใช่ firstName2, lastName2, citizenId2
      if (!value && !["business_firstname_th_2", "business_lastname_th_2", "business_full_cid_2"].includes(key)) {
        newErrors[key] = true;
      }
    });

     // ตรวจสอบ current_address
    Object.entries(formData.current_address).forEach(([key, value]) => {
    if (!value) {
      newErrors[`current_address.${key}`] = true;
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNext = () => {
    if (activeStep === 0 && !validateForm()) {
      Swal.fire({
        title: "กรุณากรอกข้อมูลให้ครบถ้วน",
        icon: "info",
        confirmButtonText: "ตกลง",
      });
      return;
    }
    setActiveStep((prevStep) => Math.min(prevStep + 1, steps.length - 1));
  };

  const handleBack = () => {
    setActiveStep((prevStep) => Math.max(prevStep - 1, 0));
  };

  const handleNewForm = () => {
    history.push("/form-personal"); // ✅ ปิดวงเล็บให้ถูกต้อง
  };

  return (
    <Box
      sx={{
        borderRadius: "20px",
        padding: "30px 5px 5px 5px",
        backgroundColor: "#f5f5f5",
      }}
    >
      <Box sx={{ height: "100%" }}>
        <Grid item xs={12}>
          <Box
            sx={{
              borderRadius: "15px",
              width: "100%",
              backgroundColor: "#ffffff",
              p: 4,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "flex-start" }}>
              <Link href="/document-personal" underline="none">
                <NavigateBeforeIcon
                  sx={{
                    fontSize: 30,
                    ml: 1,
                    cursor: "pointer",
                    mr: 1,
                    color: "#474747",
                  }}
                />
              </Link>
              <Box>
                <Typography variant="h5" sx={{ color: "#474747" }}>
                  เอกสารข้อตกลงการแบ่งปันข้อมูลส่วนบุคคล DSA
                </Typography>
              </Box>
            </Box>

            <Grid item xs={12}>
              <Box
                sx={{
                  p: 6,
                  border: "2px solid #e5eef1",
                  backgroundColor: "#f5fdff",
                  borderRadius: "10px",
                  mt: 2,
                }}
              >
                <Typography sx={{ fontSize: "20px", fontWeight: "bold" }}>
                  ใบสมัครเข้าร่วมตามนโยบาย “๓๐ บาทรักษาทุกที่
                  ด้วยบัตรประชาชนใบเดียว” ของหน่วยบริการเอกชน
                </Typography>
                <Typography sx={{ color: "#9C9C9C", fontSize: "16px" }}>
                  กรุณากรอกรายละเอียดของคุณด้านล่างเพื่อสมัครเข้าร่วมนโยบายและเริ่มต้นสร้างเอกสารสัญญา
                  เพื่อลงนามใบรับรองอิเล็กทรอนิกส์
                </Typography>

                {/* Step Content */}
                <Box sx={{ mt: 3 }}>
                  {/* {activeStep === 0 && (
                    <FormPersonalInfo
                      formData={formData}
                      setFormData={setFormData}
                      errors={errors}
                      setErrors={setErrors}
                    />
                  )
                  } */}
                  {activeStep === 1 && <ServiceInfo />}
                  {activeStep === 2 && <PersonSign />}
                  {activeStep === 3 && <AttachEvidence />}
                  <Grid container sx={{ mt: 5 }} spacing={2}>
                    <Grid item xs={12}>
                      <Divider />
                    </Grid>
                  </Grid>
                  {/* Navigation Buttons */}
                  <Grid
                    container
                    sx={{
                      mt: 3,
                      flexDirection: { xs: "column", md: "row" },
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    {" "}
                    <Grid item xs={12} md="auto" sx={{ mb: 2 }}>
                      <Button
                        variant="text"
                        color="primary"
                        sx={{ fontSize: "14px" }}
                        onClick={handleBack}
                        disabled={activeStep === 0}
                      >
                        <KeyboardArrowLeftIcon sx={{ mr: 0.5 }} />
                        ย้อนกลับ
                      </Button>
                    </Grid>
                    <Grid item xs={12} md="auto" sx={{ mb: 2 }}>
                      <Typography variant="body1">
                        {activeStep + 1} / {steps.length}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md="auto">
                      {activeStep === steps.length - 1 ? (
                        <Button
                          variant="contained"
                          sx={{
                            fontSize: "14px",
                            backgroundColor: "#2196F3",
                            borderRadius: "12px",
                            color: "white",
                            "&:hover": { backgroundColor: "#1976D2" },
                            px: 3,
                          }}
                          onClick={handleNewForm}
                        >
                          ดำเนินการต่อ
                        </Button>
                      ) : (
                        <Button
                          variant="text"
                          color="primary"
                          onClick={handleNext}
                          sx={{ fontSize: "14px" }}
                        >
                          ถัดไป <KeyboardArrowRightIcon sx={{ ml: 0.5 }} />
                        </Button>
                      )}
                    </Grid>
                  </Grid>
                </Box>
              </Box>
            </Grid>
          </Box>
        </Grid>
      </Box>
    </Box>
  );
}
